import React, { useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useCreateContentMutation } from "../../store";
import { AddForm, useTitle } from "../../components";
import JoditEditor from "jodit-react";
import { ToastContainer } from "react-toastify";

const TACA = "TERMS_AND_CONDITIONS_APPRAISER";
const TACL = "TERMS_AND_CONDITIONS_LENDER";
const PPA = "PRIVACY_POLICY_APPRAISER";
const PPL = "PRIVACY_POLICY_LENDER";

const AddContent = () => {
  const [searchParams, _] = useSearchParams(document.location.search);
  const contentType = searchParams.get("TYPE");
  const title =
    contentType === "TACA" || contentType === "TACL"
      ? "Terms & Conditions"
      : "Privacy Policy";
  const queryType =
    contentType === "TACA" ? TACA :
      contentType === "TACL" ? TACL :
        contentType === "PPA" ? PPA :
          PPL;

  const editor = useRef();
  const [content, setContent] = useState();
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      placeholder: "Write your content here...",
    }),
    []
  );
  const [
    createContent,
    {
      isLoading: isCreateContentLoading,
      isError: isCreateContentError,
      error: createContentError,
      isSuccess: isCreateContentSuccess,
    },
  ] = useCreateContentMutation();

  const resetForm = () => setContent("");

  const submitHandler = async (e) => {
    e.preventDefault();

    let title;

    if (contentType === "TACA") {
      title = TACA;
    } else if (contentType === "PPA") {
      title = PPA;
    }
    else if (contentType === "TACL") {
      title = TACL;
    }
    else if (contentType === "PPL") {
      title = PPL;
    }
    console.log("......add content", { title, content });
    createContent({ title, content });
    resetForm();
  };

  useTitle(`Content | ${title}`);
  return (
    <AddForm
      title={`Add ${title}`}
      data={{}}
      setData={() => { }}
      inputFieldProps={[]}
      submitHandler={submitHandler}
      target="/admin/content"
      successMessage={`${title} Created Successfully!`}
      reducerProps={{
        loading: isCreateContentLoading,
        error: createContentError,
        success: isCreateContentSuccess,
      }}
    >
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        tabIndex={1} // tabIndex of textarea
        // onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
        onChange={(newContent) => setContent(newContent)}
      />
      {/* {content} */}
      <ToastContainer />
    </AddForm>
  );
};

export default AddContent;
